/*
  «Build your pack» (snippets/aoa-bundle-builder.liquid). Dibuja los pasos del pack a partir del JSON del snippet y
  agrega al carrito con el mismo formato que assets/bundle-picker.js (una línea por prenda con _bundle,
  _bundle_handle y _bundle_slot), para que los descuentos de pack sigan funcionando igual.
  Comportamiento de la maqueta aprobada (Compuertas/Mix 3 Pack Bundle design, 2026-10-15): un paso abierto a la
  vez; al completar color y talla se cierra y se abre el siguiente pendiente; las tarjetas de arriba muestran la
  foto del color elegido; colores y tallas sin stock quedan deshabilitados con un aviso en texto.
*/
(function () {
  'use strict';
  if (window.aoaBundleBuilder) return;

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var GHOST = '<span class="bd-slot__ghost" aria-hidden="true"><svg viewBox="0 0 48 48"><path d="M16 6l8 4 8-4 10 8-5 6-4-2v24H15V18l-4 2-5-6z"></path></svg></span>';
  var CHECK = '<span class="bd-slot__check" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg></span>';
  var CHEV = '<svg class="bd-step__chev" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"></path></svg>';

  function Builder(root) {
    var json = root.querySelector('[data-bd-data]');
    if (!json) return;
    this.root = root;
    this.data = JSON.parse(json.textContent);
    this.slots = this.data.slots;
    this.sel = this.slots.map(function () { return { group: null, color: null, size: null }; });
    this.open = 0;
    this.uid = 'bd' + Math.random().toString(36).slice(2, 7);
    // Prendas sin elección posible (una sola variante) quedan listas desde el inicio
    var self = this;
    this.slots.forEach(function (s, i) {
      if (!s.colorPos && !s.sizePos) self.sel[i].fixed = true;
      // Una sola talla (One Size) o un solo color: quedan elegidos, no hay nada que decidir
      if (s.sizePos && s.sizes.length === 1) self.sel[i].size = s.sizes[0];
      var colores = [];
      (s.groups || []).forEach(function (g, gi) { g.colors.forEach(function (c) { colores.push({ g: gi, name: c.name }); }); });
      if (s.colorPos && colores.length === 1) { self.sel[i].color = colores[0].name; self.sel[i].group = colores[0].g; }
    });
    this.open = this.firstPending(0);
    this.bind();
    this.render();
    this.fromBag();
  }

  // Desde la nota de pack de la bolsa (snippets/aoa-cart-bundle-nudge.liquid, ?aoa_desde=bolsa): las prendas sueltas
  // que el cliente ya eligió entran en los primeros espacios con su color y talla, y al agregar el pack salen de la
  // bolsa (Bryan 2026-10-22: «tendrían que estar las dos primeras prendas escogidas por el cliente»)
  Builder.prototype.fromBag = function () {
    if (!/[?&]aoa_desde=bolsa(&|$)/.test(location.search)) return;
    var self = this, root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var used = {}, n = 0; // unidades tomadas por variante
        (cart.items || []).forEach(function (it) {
          if (it.properties && it.properties._bundle) return;
          for (var u = 0; u < it.quantity; u++) {
            var i = -1, v = null;
            for (var k = 0; k < self.slots.length; k++) {
              if (self.sel[k].fromBag || self.isDone(k)) continue;
              v = self.slots[k].variants.find(function (x) { return x.id === it.variant_id && x.available; });
              if (v) { i = k; break; }
            }
            if (i < 0) return;
            var slot = self.slots[i], color = slot.colorPos ? v.options[slot.colorPos - 1] : null;
            self.sel[i].color = color;
            self.sel[i].group = color ? (slot.groups || []).findIndex(function (g) { return g.colors.some(function (c) { return c.name === color; }); }) : null;
            self.sel[i].size = slot.sizePos ? v.options[slot.sizePos - 1] : null;
            self.sel[i].fromBag = true;
            used[it.variant_id] = (used[it.variant_id] || 0) + 1;
            n++;
          }
        });
        if (!n) return;
        self.bag = { used: used, n: n };
        self.open = self.firstPending(0);
        self.render();
      })
      .catch(function () {});
  };

  // Saca de la bolsa las prendas sueltas que pasaron al pack (solo después de agregar el pack con éxito). Se relee
  // la bolsa y se actualiza por posición de línea: Shopify cambia la clave de la línea cuando entra un descuento
  // automático, y una clave vieja hace que borre otra línea de la misma variante (prueba del 2026-10-22)
  Builder.prototype.removeFromBag = function () {
    if (!this.bag) return Promise.resolve();
    var used = Object.assign({}, this.bag.used), root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    this.bag = null;
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = (cart.items || []).map(function (it) {
          if ((it.properties && it.properties._bundle) || !used[it.variant_id]) return it.quantity;
          var take = Math.min(it.quantity, used[it.variant_id]);
          used[it.variant_id] -= take;
          return it.quantity - take;
        });
        return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) });
      });
  };

  Builder.prototype.variantFor = function (slot, color, size) {
    return slot.variants.find(function (v) {
      return (!slot.colorPos || v.options[slot.colorPos - 1] === color) && (!slot.sizePos || v.options[slot.sizePos - 1] === size);
    }) || null;
  };
  Builder.prototype.colorSoldOut = function (slot, color) {
    return !slot.variants.some(function (v) { return v.available && v.options[slot.colorPos - 1] === color; });
  };
  Builder.prototype.sizeDisabled = function (slot, color, size) {
    if (slot.colorPos && color) {
      var v = this.variantFor(slot, color, size);
      return !v || !v.available;
    }
    return !slot.variants.some(function (v) { return v.available && v.options[slot.sizePos - 1] === size; });
  };
  Builder.prototype.chosenVariant = function (i) {
    var slot = this.slots[i], s = this.sel[i];
    if (s.fixed) return slot.variants[0] && slot.variants[0].available ? slot.variants[0] : null;
    if ((slot.colorPos && !s.color) || (slot.sizePos && !s.size)) return null;
    var v = this.variantFor(slot, s.color, s.size);
    return v && v.available ? v : null;
  };
  Builder.prototype.isDone = function (i) { return !!this.chosenVariant(i); };
  Builder.prototype.firstPending = function (from) {
    for (var k = 0; k < this.slots.length; k++) {
      var i = (from + k) % this.slots.length;
      if (!this.isDone(i)) return i;
    }
    return null;
  };
  Builder.prototype.imageFor = function (i) {
    var slot = this.slots[i], s = this.sel[i];
    if (!s.color) return null;
    var v = slot.variants.find(function (x) { return x.image && x.options[slot.colorPos - 1] === s.color && (!s.size || x.options[slot.sizePos - 1] === s.size); }) ||
      slot.variants.find(function (x) { return x.image && x.options[slot.colorPos - 1] === s.color; });
    return v ? v.image : slot.image;
  };
  Builder.prototype.status = function (i) {
    var slot = this.slots[i], s = this.sel[i];
    if (s.fixed) return 'Included';
    // Talla única (One Size): no se menciona, no hay nada que elegir
    if (slot.sizePos && slot.sizes.length === 1) {
      if (!slot.colorPos) return s.size;
      return s.color ? s.color : 'Choose a color';
    }
    var need = [];
    if (slot.colorPos && !s.color) need.push('color');
    if (slot.sizePos && !s.size) need.push('size');
    if (s.color && s.size) return s.color + ' · ' + s.size;
    if (s.color && slot.sizePos) return s.color + ' · pick a size';
    if (s.color) return s.color;
    if (s.size && slot.colorPos) return 'Size ' + s.size + ' · pick a color';
    if (s.size) return 'Size ' + s.size;
    return 'Choose ' + need.join(' and ');
  };

  Builder.prototype.set = function (i, patch) {
    var wasDone = this.isDone(i);
    Object.assign(this.sel[i], patch);
    if (!wasDone && this.isDone(i)) {
      var next = this.firstPending(i + 1);
      this.open = next;
    }
    this.render(true);
  };

  Builder.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-bd-act]');
      if (!t || !self.root.contains(t)) return;
      var act = t.getAttribute('data-bd-act'), i = +t.getAttribute('data-i');
      if (act === 'open') { self.open = self.open === i && t.classList.contains('bd-step__head') ? null : i; self.render(true); }
      else if (act === 'color') {
        if (t.getAttribute('aria-disabled') === 'true') { self.sel[i].oos = t.getAttribute('data-v') + ' is sold out in every size.'; self.render(true); return; }
        self.sel[i].oos = '';
        var nc = t.getAttribute('data-v'), sz = self.sel[i].size;
        // La talla elegida no existe o no tiene stock en el color nuevo: se limpia para no dejar un paso imposible
        if (sz && self.sizeDisabled(self.slots[i], nc, sz)) { self.sel[i].size = null; self.sel[i].oos = nc + ' in ' + sz + ' is out of stock. Pick another size.'; }
        self.set(i, { group: +t.getAttribute('data-g'), color: nc });
      }
      else if (act === 'size') {
        if (t.getAttribute('aria-disabled') === 'true') {
          var s = self.sel[i];
          self.sel[i].oos = (s.color ? s.color + ' in ' : 'Size ') + t.getAttribute('data-v') + ' is out of stock.';
          self.render(true); return;
        }
        self.sel[i].oos = '';
        self.set(i, { size: t.getAttribute('data-v') });
      }
      else if (act === 'guide') {
        var href = t.getAttribute('href') || '';
        if (href.charAt(0) === '#') {
          e.preventDefault();
          var el = document.querySelector(href);
          if (el) { if (el.tagName === 'DETAILS') el.open = true; el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        }
      }
    });
    var add = this.root.querySelector('[data-bd-add]');
    if (add) add.addEventListener('click', function () { self.addToCart(add); });
  };

  Builder.prototype.render = function (keepFocus) {
    var self = this, N = this.slots.length, done = 0;
    var focusKey = keepFocus && document.activeElement && this.root.contains(document.activeElement) ? document.activeElement.getAttribute('data-k') : null;
    this.slots.forEach(function (s, i) { if (self.isDone(i)) done++; });
    var all = done === N;
    this.root.style.setProperty('--bd-cols', String(Math.min(N, 5)));
    this.root.style.setProperty('--bd-cols-m', String(Math.min(N, 4)));
    this.root.style.setProperty('--bd-n', String(N));

    var count = this.root.querySelector('[data-bd-count]');
    count.textContent = done + '/' + N + ' complete';
    count.classList.toggle('is-done', all);
    this.root.querySelector('[data-bd-bar]').innerHTML = this.slots.map(function (s, i) { return '<span class="' + (i < done ? 'is-on' : '') + '"></span>'; }).join('');

    this.root.querySelector('[data-bd-slots]').innerHTML = this.slots.map(function (slot, i) {
      var img = self.imageFor(i), isDone = self.isDone(i), s = self.sel[i];
      var unaTalla = slot.sizePos && slot.sizes.length === 1;
      var sub = s.fixed ? 'Included' : (s.color ? s.color + (s.size && !unaTalla ? ' · ' + s.size : '') : (s.size && !unaTalla ? 'Size ' + s.size : 'Not chosen'));
      return '<button type="button" class="bd-slot' + (self.open === i ? ' is-active' : '') + (img || s.fixed ? ' is-filled' : '') + '" data-bd-act="open" data-i="' + i + '" data-k="slot' + i + '" aria-label="' + esc(slot.name + ': ' + self.status(i)) + '">' +
        '<span class="bd-slot__media">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="480" height="600">' : (s.fixed && slot.image ? '<img src="' + esc(slot.image) + '" alt="" loading="lazy" width="480" height="600">' : GHOST)) + (isDone ? CHECK : '') + '</span>' +
        '<span class="bd-slot__name">' + esc(slot.name) + '</span><span class="bd-slot__sub">' + esc(sub) + '</span></button>';
    }).join('');

    this.root.querySelector('[data-bd-steps]').innerHTML = this.slots.map(function (slot, i) {
      var s = self.sel[i], open = self.open === i, isDone = self.isDone(i);
      var v = self.chosenVariant(i) || slot.variants[0];
      var body = '';
      if (open && !s.fixed) {
        var id = self.uid + '-' + i;
        body += '<div class="bd-step__body" id="' + id + '">';
        (slot.groups || []).forEach(function (g, gi) {
          var inGroup = s.color && g.colors.some(function (c) { return c.name === s.color; });
          body += '<div class="rd-label-row"><span class="label">' + esc(g.header) + ': <strong>' + esc(inGroup ? s.color : 'Select a color') + '</strong></span>' +
            (g.link && g.linkText ? '<a href="' + esc(g.link) + '">' + esc(g.linkText) + '</a>' : '') + '</div>';
          body += '<div class="rd-swatches" role="group" aria-label="' + esc(g.header + ' colors') + '">' + g.colors.map(function (c) {
            var out = self.colorSoldOut(slot, c.name);
            return '<button type="button" class="rd-swatch" style="background: ' + esc(c.hex) + '" data-bd-act="color" data-i="' + i + '" data-g="' + gi + '" data-v="' + esc(c.name) + '" data-k="c' + i + '-' + esc(c.name) + '" aria-pressed="' + (s.color === c.name) + '" aria-disabled="' + out + '" aria-label="' + esc(c.name + (out ? ', out of stock' : '')) + '" title="' + esc(c.name) + '"></button>';
          }).join('') + '</div>';
        });
        if (slot.sizePos) {
          body += '<div class="rd-label-row"><span class="label">Size</span>' + (self.data.sizeGuide ? '<a href="' + esc(self.data.sizeGuide) + '" data-bd-act="guide" data-i="' + i + '">' + esc(self.data.sizeGuideLabel) + '</a>' : '') + '</div>';
          // Talla única: es información, no se elige (ya queda elegida arriba); va como texto, igual que en la ficha
          // (snippets/product-option.liquid, --unica; Bryan 2026-10-30: «esto no sería un botón porque solo es información»)
          if (slot.sizes.length === 1) body += '<p class="bd-size-unica">' + esc(slot.sizes[0]) + '</p>';
          else body += '<div class="rd-sizes" role="group" aria-label="Size">' + slot.sizes.map(function (z) {
            var dis = self.sizeDisabled(slot, s.color, z);
            return '<button type="button" class="rd-size" data-bd-act="size" data-i="' + i + '" data-v="' + esc(z) + '" data-k="s' + i + '-' + esc(z) + '" aria-pressed="' + (s.size === z) + '" aria-disabled="' + dis + '" aria-label="' + esc('Size ' + z + (dis ? ', out of stock' : '')) + '">' + esc(z) + '</button>';
          }).join('') + '</div>';
        }
        if (s.oos) body += '<p class="bd-oos" role="status">' + esc(s.oos) + '</p>';
        body += '</div>';
      }
      // Stock bajo de la prenda elegida («Only X left», 5 o menos): va fuera del cuerpo para seguir a la vista con el paso cerrado
      var elegida = self.chosenVariant(i);
      var stock = elegida && elegida.low > 0
        ? '<p class="rd-stock bd-step__stock">' + esc(String(self.data.lowStockText || 'Only [quantity] left').replace('[quantity]', elegida.low)) + '</p>'
        : '';
      return '<section class="bd-step' + (open ? ' is-open' : '') + (isDone ? ' is-done' : '') + '">' +
        '<button type="button" class="bd-step__head" data-bd-act="open" data-i="' + i + '" data-k="head' + i + '" aria-expanded="' + open + '"' + (open && !s.fixed ? ' aria-controls="' + self.uid + '-' + i + '"' : '') + '>' +
        '<span class="bd-step__num" aria-hidden="true">' + (i + 1) + '</span>' +
        '<span class="bd-step__titles"><span class="bd-step__title">' + esc(slot.name) + '</span><span class="bd-step__status">' + esc(self.status(i)) + '</span></span>' +
        '<span class="bd-step__price">' + esc(v ? v.price : '') + CHEV + '</span></button>' + stock + body + '</section>';
    }).join('');

    var add = this.root.querySelector('[data-bd-add]');
    add.disabled = !all;
    var names = this.slots.map(function (s) { return s.name; });
    // Con talla única no se pide talla: ya queda elegida (2026-10-30, salía «Pick a color and a size» en los gorros)
    function eligeTalla(s) { return s.sizePos && s.sizes.length > 1; }
    var list = names.length > 1 ? names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] : names[0];
    this.root.querySelector('[data-bd-hint]').textContent = all
      ? list + ', ready to add.'
      : done + ' of ' + N + ' chosen. Pick ' + (this.slots.some(function (s) { return s.colorPos; }) ? 'a color' : '') +
        (this.slots.some(function (s) { return s.colorPos; }) && this.slots.some(eligeTalla) ? ' and ' : '') +
        (this.slots.some(eligeTalla) ? 'a size' : '') + ' for each piece.';
    if (this.bag) {
      this.root.querySelector('[data-bd-hint]').textContent += this.bag.n === 1
        ? ' The piece from your bag moves into this pack.'
        : ' The ' + this.bag.n + ' pieces from your bag move into this pack.';
    }

    if (focusKey) {
      var f = this.root.querySelector('[data-k="' + (window.CSS && CSS.escape ? CSS.escape(focusKey) : focusKey) + '"]');
      if (f) f.focus({ preventScroll: true });
    }
    this.root.dispatchEvent(new CustomEvent('aoa-bundle:change', { bubbles: true, detail: { done: done, total: N } }));
  };

  Builder.prototype.addToCart = function (btn) {
    var self = this, err = this.root.querySelector('[data-bd-error]');
    if (btn.disabled || btn.classList.contains('loading')) return;
    var items = this.slots.map(function (slot, i) {
      var v = self.chosenVariant(i);
      return v ? { id: v.id, quantity: 1, properties: { _bundle: self.root.getAttribute('data-bundle-title') || '', _bundle_handle: self.root.getAttribute('data-bundle-handle') || '', _bundle_slot: String(i + 1) } } : null;
    });
    if (items.some(function (x) { return !x; })) return;
    err.hidden = true;
    btn.classList.add('loading'); btn.disabled = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) {
        if (r.ok) return r.json();
        return r.json().catch(function () { return {}; }).then(function (d) { throw new Error(d.description || d.message || "Couldn't add your pack. Please try again."); });
      })
      .then(function () { return self.removeFromBag(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { items: items } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var toggle = document.getElementById('cart-drawer-toggle');
        if (toggle) toggle.click();
      })
      .catch(function (e) { err.textContent = e.message; err.hidden = false; })
      .finally(function () { btn.classList.remove('loading'); btn.disabled = false; });
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-aoa-bundle]:not([data-bd-ready])').forEach(function (el) {
      el.setAttribute('data-bd-ready', '');
      el.aoaBundle = new Builder(el);
    });
  }
  window.aoaBundleBuilder = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
